<template>
    <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.25 0.370361H11.871L17.5 6.08221V19.4676C17.5 19.8052 17.3683 20.1291 17.1339 20.3678C16.8995 20.6066 16.5815 20.7407 16.25 20.7407H1.25C0.918479 20.7407 0.60054 20.6066 0.366119 20.3678C0.131699 20.1291 0 19.8052 0 19.4676V1.64351C0 1.30585 0.131699 0.982022 0.366119 0.743261C0.60054 0.504499 0.918479 0.370361 1.25 0.370361Z"
            :fill="color || '#FBFBFB'"
        />
    </svg>
</template>
<script>
export default {
    name: "Pdf",
    props: ["color"],
};
</script>


// WEBPACK FOOTER //
// src/components/V2/svg/components/Pdf.vue